import { componentQrl, inlinedQrl, _jsxBranch, _jsxC, Slot } from "@builder.io/qwik";
import { Fragment } from "@builder.io/qwik/jsx-runtime";
import { isEmptyElement } from "./dynamic-renderer.helpers.qwik.mjs";
const DynamicRenderer = /* @__PURE__ */ componentQrl(/* @__PURE__ */ inlinedQrl((props) => {
  _jsxBranch();
  return /* @__PURE__ */ _jsxC(Fragment, {
    children: !isEmptyElement(props.TagName) ? typeof props.TagName === "string" ? /* @__PURE__ */ _jsxC(props.TagName, {
      ...props.attributes,
      ...props.actionAttributes,
      children: /* @__PURE__ */ _jsxC(Slot, null, 3, "yW_0")
    }, 0, "yW_1") : /* @__PURE__ */ _jsxC(props.TagName, {
      ...props.attributes,
      ...props.actionAttributes,
      children: /* @__PURE__ */ _jsxC(Slot, null, 3, "yW_2")
    }, 0, "yW_3") : /* @__PURE__ */ _jsxC(props.TagName, {
      ...props.attributes,
      ...props.actionAttributes
    }, 0, "yW_4")
  }, 1, "yW_5");
}, "DynamicRenderer_component_1Co0xkmyAfQ"));
export {
  DynamicRenderer,
  DynamicRenderer as default
};
